// OperationInspectionRecord 巡检记录 已去除
// OperationMaintenanceRecord 故障维修记录 已去除
/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/Login',
    name: 'Login',
    component: () => import('@/views/Login/Login.vue'), // 登录页面
  },

  {
    path: '/Home',
    name: 'Home',
    redirect: '/HomeInfo',
    component: () => import('@/views/Handover/Home.vue'), // 首页布局
    children: [
      {
        path: '/ProjectInfo',
        name: 'ProjectInfo',
        redirect: '/ProjectInfo/ProjectAll',
        component: () => import('@/views/Before/ProjectInfo'), // 项目信息模块
        children: [
          //工作台
          {
            path: '/ProjectInfo/ProjectAll',
            name: 'ProjectAll',
            component: () => import('@/views/Before/ProjectInfo/ProjectAll'), // 项目总览
          },
          //设备审核
          {
            path: '/ProjectInfo/ProjectDeviceAudit',
            name: 'ProjectDeviceAudit',
            component: () =>
              import('@/views/Before/ProjectInfo/ProjectDeviceAudit.vue'), // 设备审核
          },
          //供应商资质审核
          {
            path: '/ProjectInfo/TeamAuditDocument',
            name: 'TeamAuditDocument',
            component: () =>
              import('@/views/Before/ProjectInfo/TeamAuditDocument.vue'),
          },
          //项目资料审核
          {
            path: '/ProjectInfo/ProjectDocument',
            name: 'ProjectDocument',
            component: () =>
              import('@/views/Before/ProjectInfo/ProjectDocument.vue'),
          },
          //通用备件审核
          {
            path: '/ProjectInfo/SparesReview',
            name: 'SparesReview',
            component: () =>
              import('@/views/Before/ProjectInfo/SparesReview.vue'),
          },
          //供应商统计
          {
            path: '/ProjectInfo/SupplierStatistics',
            name: 'SupplierStatistics',
            component: () =>
              import('@/views/Before/ProjectInfo/SupplierStatistics.vue'),
          },
          // // 设备统计
          // {
          //   path: '/ProjectInfo/DeviceStatistic',
          //   name: 'Spare',
          //   component: () =>
          //     import('@/views/Before/ProjectInfo/DeviceStatistic.vue'), // 设备统计
          // },
          // // 供应商统计
          // {
          //   path: '/ProjectInfo/SupplierStatistic',
          //   name: 'SupplierStatistic',
          //   component: () =>
          //     import('@/views/Before/ProjectInfo/SupplierStatistic.vue'), // 供应商统计
          // },
        ],
      },

      //项目文件
      {
        path: '/ProjectInfo/File',
        name: 'File',
        component: () => import('@/views/Before/ProjectInfo/File.vue'), // 项目文件
      },
      // 项目统计
      {
        path: '/ProjectInfo/ProjectOverview',
        name: 'Spare',
        component: () =>
          // src\views\Before\ProjectOverview\ProjectOverview.vue
          import('@/views/Before/ProjectOverview/ProjectOverview.vue'), // 项目统计
      },

      {
        path: '/HomeInfo',
        name: 'HomeInfo',
        component: () => import('@/views/HomeInfo/HomeInfo'), // 首页信息
      },

      {
        path: '/DeviceAccounts',
        name: 'DeviceAccounts',
        component: () => import('@/views/DeviceAccounts/DeviceAccounts'), // 台账
      },
      {
        path: '/DeviceAnalysis',
        name: 'DeviceAnalysis',
        component: () => import('@/views/DeviceAnalysis/DeviceAnalysis'), // 设备分析
      },
      {
        path: '/DeviceAnnualInspection',
        name: 'DeviceAnnualInspection',
        component: () =>
          import('@/views/DeviceAnnualInspection/DeviceAnnualInspection'), // 设备分析
      },

      {
        path: '/FittingsClassification',
        name: 'FittingsClassification',
        component: () =>
          import(
            '@/views/Fittings/FittingsClassification/FittingsClassification'
          ), // 备件分类
      },
      {
        path: '/FittingsRecord',
        name: 'FittingsRecord',
        component: () =>
          import('@/views/Fittings/FittingsRecord/FittingsRecord'), // 备件档案
      },
       {
        path: '/FittingsHome',
        name: 'FittingsHome',
        component: () => import('@/views/Fittings/FittingsHome/FittingsHome'), // 备件台账
      },
      {
        path: '/FittingsBePut',
        name: 'FittingsBePut',
        component: () => import('@/views/Fittings/FittingsBePut/FittingsBePut'), // 备件入库
      },
      {
        path: '/FittingsDelivery',
        name: 'FittingsDelivery',
        component: () =>
          import('@/views/Fittings/FittingsDelivery/FittingsDelivery'), // 备件出库
      },
      {
        path: '/FittingsCheck',
        name: 'FittingsCheck',
        component: () => import('@/views/Fittings/FittingsCheck/FittingsCheck'), // 库存盘点
      },
      {
        path: '/FittingsFlows',
        name: 'FittingsFlows',
        component: () => import('@/views/Fittings/FittingsFlows/FittingsFlows'), // 出入库流水
      },
      {
        path: '/FittingsInventoryBalance',
        name: 'FittingsInventoryBalance',
        component: () =>
          import(
            '@/views/Fittings/FittingsInventoryBalance/FittingsInventoryBalance'
          ), // 备件结存
      },
      {
        path: '/FittingsAnalysis',
        name: 'FittingsAnalysis',
        component: () =>
          import('@/views/Fittings/FittingsAnalysis/FittingsAnalysis'), // 出入库流水
      },
      {
        path: '/OperationPlan',
        name: 'OperationPlan',
        component: () =>
          import('@/views/Operation/OperationPlan/OperationPlan'), // 运维计划
      },
      {
        path: '/OperationTaskPlanning',
        name: 'OperationTaskPlanning',
        component: () =>
          import(
            '@/views/Operation/OperationTaskPlanning/OperationTaskPlanning'
          ), // 保养计划
      },
      {
        path: '/OperationPollingPlanning',
        name: 'OperationPollingPlanning',
        component: () =>
          import(
            '@/views/Operation/OperationPollingPlanning/OperationPollingPlanning'
          ), // 巡检计划
      },
      {
        path: '/OperationWorkOrder',
        name: 'OperationWorkOrder',
        component: () =>
          import('@/views/Operation/OperationWorkOrder/OperationWorkOrder'), // 工单管理
      },
      {
        path: '/OperationMalfunction',
        name: 'OperationMalfunction',
        component: () =>
          import('@/views/Operation/OperationMalfunction/OperationMalfunction'), // 故障报修
      },
      {
        path: '/OperationStopPower',
        name: 'OperationStopPower',
        component: () =>
          import('@/views/Operation/OperationStopPower/OperationStopPower'), // 停开机记录
      },
      {
        path: '/OperationStopPowerPlan',
        name: 'OperationStopPowerPlan',
        component: () =>
          import(
            '@/views/Operation/OperationStopPowerPlan/OperationStopPowerPlan'
          ), // 停开机计划
      },
      {
        path: '/OperationScrap',
        name: 'OperationScrap',
        component: () =>
          import('@/views/Operation/OperationScrap/OperationScrap'), // 设备报废
      },
      {
        path: '/InspectionWorkOrder',
        name: 'InspectionWorkOrder',
        component: () =>
          import('@/views/Operation/InspectionWorkOrder/InspectionWorkOrder'), // 巡检工单
      },
      {
        path: '/OutsourcedWorkOrder',
        name: 'OutsourcedWorkOrder',
        component: () =>
          import('@/views/Operation/OutsourcedWorkOrder/OutsourcedWorkOrder'), // 外委工单
      },
      {
        path: '/FaultWorkOrder',
        name: 'FaultWorkOrder',
        component: () =>
          import('@/views/Operation/FaultWorkOrder/FaultWorkOrder'), // 维修工单
      },
      {
        path: '/MaintenanceWorkOrder',
        name: 'MaintenanceWorkOrder',
        component: () =>
          import('@/views/Operation/MaintenanceWorkOrder/MaintenanceWorkOrder'), // 保养工单
      },
      // {
      //   path: '/OperationInspectionRecord',
      //   name: 'OperationInspectionRecord',
      //   component: () =>
      //     import(
      //       '@/views/Operation/OperationInspectionRecord/OperationInspectionRecord'
      //     ), // 巡检记录
      // },
      {
        path: '/FaultMaintenanceRecord',
        name: 'FaultMaintenanceRecord',
        component: () =>
          import(
            '@/views/Operation/FaultMaintenanceRecord/FaultMaintenanceRecord'
          ), // 故障维修记录
      },
      {
        path: '/OutsourcingMaintenanceRecord',
        name: 'OutsourcingMaintenanceRecord',
        component: () =>
          import(
            '@/views/Operation/OutsourcingMaintenanceRecord/OutsourcingMaintenanceRecord'
          ), // 外委维修记录
      },
      {
        path: '/OperationInspectionRecordInfo',
        name: 'OperationInspectionRecordInfo',
        component: () =>
          import(
            '@/views/Operation/OperationInspectionRecordInfo/OperationInspectionRecordInfo'
          ), // 巡检分析
      },
       {
        path: '/OperationDataAnalysis',
        name: 'OperationDataAnalysis',
        component: () =>
          import(
            '@/views/Operation/OperationDataAnalysis/OperationDataAnalysis'
          ), // 运维数据分析
      },
       {
        path: '/DeviceDataAnalysis',
        name: 'DeviceDataAnalysis',
        component: () =>
          import(
            '@/views/Operation/DeviceDataAnalysis/DeviceDataAnalysis'
          ), // 设备分布分析
      },
      {
        path: '/FaultShutdownAnalysis',
        name: 'FaultShutdownAnalysis',
        component: () =>
          import(
            '@/views/Operation/FaultShutdownAnalysis/FaultShutdownAnalysis'
          ), // 设备故障/停机分析
      },
      // {
      //   path: '/OperationMaintenanceRecord',
      //   name: 'OperationMaintenanceRecord',
      //   component: () =>
      //     import(
      //       '@/views/Operation/OperationMaintenanceRecord/OperationMaintenanceRecord'
      //     ), // 维修管理
      // },
      {
        path: '/ReportDeviceInfo',
        name: 'ReportDeviceInfo',
        component: () =>
          import('@/views/Report/ReportDeviceInfo/ReportDeviceInfo.vue'), // 设备信息报表
      },
      {
        path: '/ReportFittingInfo',
        name: 'ReportFittingInfo',
        component: () =>
          import('@/views/Report/ReportFittingInfo/ReportFittingInfo.vue'), // 备件信息报表
      },
      {
        path: '/ReportOperationCostInfo',
        name: 'ReportOperationCostInfo',
        component: () =>
          import(
            '@/views/Report/ReportOperationCostInfo/ReportOperationCostInfo.vue'
          ), // 运维成本分析
      },
      {
        path: '/ReportEnergyInfo',
        name: 'ReportEnergyInfo',
        component: () =>
          import('@/views/Report/ReportEnergyInfo/ReportEnergyInfo.vue'), // 总能耗成本
      },
      {
        path: '/ReportEnergyGas',
        name: 'ReportEnergyGas',
        component: () =>
          import('@/views/Report/ReportEnergyGas/ReportEnergyGas.vue'), // 气能耗成本
      },
      {
        path: '/ReportEnergyWater',
        name: 'ReportEnergyWater',
        component: () =>
          import('@/views/Report/ReportEnergyWater/ReportEnergyWater.vue'), // 水能耗成本
      },
      {
        path: '/ReportEnergyElectricity',
        name: 'ReportEnergyElectricity',
        component: () =>
          import(
            '@/views/Report/ReportEnergyElectricity/ReportEnergyElectricity.vue'
          ), // 电能耗成本
      },
      {
        path: '/ReportEnergyOil',
        name: 'ReportEnergyOil',
        component: () =>
          import('@/views/Report/ReportEnergyOil/ReportEnergyOil.vue'), // 油能耗成本
      },
      {
        path: '/ReportEnergyHeating',
        name: 'ReportEnergyHeating',
        component: () =>
          import('@/views/Report/ReportEnergyHeating/ReportEnergyHeating.vue'), // 热能耗成本
      },
       {
        path: '/EnergyAnalysis',
        name: 'EnergyAnalysis',
        component: () =>
          import('@/views/Report/EnergyAnalysis/EnergyAnalysis.vue'), // 能耗分析
      },
      {
        path: '/ReportDeviceCostInfo',
        name: 'ReportDeviceCostInfo',
        component: () =>
          import(
            '@/views/Report/ReportDeviceCostInfo/ReportDeviceCostInfo.vue'
          ), // 设备成本分析
      },
      {
        path: '/ReportFullCycleCost',
        name: 'ReportFullCycleCost',
        component: () =>
          import('@/views/Report/ReportFullCycleCost/ReportFullCycleCost.vue'), // 全周期成本
      },
      {
        path: '/ReportAssetAnalysis',
        name: 'ReportAssetAnalysis',
        component: () =>
          import('@/views/Report/ReportAssetAnalysis/ReportAssetAnalysis.vue'), // 资产分析
      },

      {
        path: '/ReportWorkOrder',
        name: 'ReportWorkOrder',
        component: () =>
          import('@/views/Report/ReportWorkOrder/ReportWorkOrder.vue'), // 工单分析
      },
      {
        path: '/ReportMaintain',
        name: 'ReportMaintain',
        component: () =>
          import('@/views/Report/ReportMaintain/ReportMaintain.vue'), // 维修分析
      },
      {
        path: '/ReportWorkOrderInfo',
        name: 'ReportWorkOrderInfo',
        component: () =>
          import('@/views/Report/ReportWorkOrderInfo/ReportWorkOrderInfo.vue'), // 保养分析
      },
      {
        path: '/BasicsMeasuringunit',
        name: 'BasicsMeasuringunit',
        component: () =>
          import('@/views/Basics/BasicsMeasuringunit/BasicsMeasuringunit.vue'), // 计量单位
      },
      {
        path: '/BasicsWarehouse',
        name: 'BasicsWarehouse',
        component: () =>
          import('@/views/Basics/BasicsWarehouse/BasicsWarehouse.vue'), // 库区管理
      },
      {
        path: '/BasicsShelf',
        name: 'BasicsShelf',
        component: () => import('@/views/Basics/BasicsShelf/BasicsShelf.vue'), // 货位管理
      },
      {
        path: '/BasicsSupplier',
        name: 'BasicsSupplier',
        component: () =>
          import('@/views/Basics/BasicsSupplier/BasicsSupplier.vue'), // 供应商
      },
      {
        path: '/BasicsSupplierInformation',
        name: 'BasicsSupplierInformation',
        component: () =>
          import('@/views/Basics/BasicsSupplierInformation/BasicsSupplierInformation.vue'), // 供应商资料
      },
      {
        path: '/BasicsEnergyPrice',
        name: 'BasicsEnergyPrice',
        component: () =>
          import('@/views/Basics/BasicsEnergyPrice/BasicsEnergyPrice.vue'), // 价格表
      },
      {
        path: '/BasicsEnergyPriceAnalysis',
        name: 'BasicsEnergyPriceAnalysis',
        component: () =>
          import('@/views/Basics/BasicsEnergyPriceAnalysis/BasicsEnergyPriceAnalysis.vue'), // 价格表
      },
      {
        path: '/BasicsEnergyData',
        name: 'BasicsEnergyData',
        component: () =>
          import('@/views/Basics/BasicsEnergyData/BasicsEnergyData.vue'), // 采集
      },
      {
        path: '/AssetType',
        name: 'AssetType',
        component: () => import('@/views/Asset/AssetType/AssetType.vue'), // 资产类型
      },
      {
        path: '/AssetCategory',
        name: 'AssetCategory',
        component: () =>
          import('@/views/Asset/AssetCategory/AssetCategory.vue'), // 资产分类
      },
      {
        path: '/AssetInfo',
        name: 'AssetInfo',
        component: () => import('@/views/Asset/AssetInfo/AssetInfo.vue'), // 资产卡
      },
      {
        path: '/AssetDepreciation',
        name: 'AssetDepreciation',
        component: () =>
          import('@/views/Asset/AssetDepreciation/AssetDepreciation.vue'), // 资产折旧
      },
      {
        path: '/AssetDepreciationSearch',
        name: 'AssetDepreciationSearch',
        component: () =>
          import('@/views/Asset/AssetDepreciation/AssetDepreciationSearch.vue'), // 折旧查询
      },
      {
        path: '/AssetDepreciationTotal',
        name: 'AssetDepreciationTotal',
        component: () =>
          import('@/views/Asset/AssetDepreciation/AssetDepreciationTotal.vue'), // 折旧统计
      },
      {
        path: '/AssetDisposal',
        name: 'AssetDisposal',
        component: () =>
          import('@/views/Asset/AssetDisposal/AssetDisposal.vue'), // 资产处置
      },
      {
        path: '/AssetDisposalSearch',
        name: 'AssetDisposalSearch',
        component: () =>
          import('@/views/Asset/AssetDisposal/AssetDisposalSearch.vue'), // 处置统计
      },
      {
        path: '/Department',
        name: 'Department',
        component: () => import('@/views/Asset/Department/Department.vue'), // 部门信息
      },

      {
        path: '/SystemInit',
        name: 'SystemInit',
        component: () => import('@/views/System/SystemInit/SystemInit'), // 数据初始化
      },
      {
        path: '/SystemRole',
        name: 'SystemRole',
        component: () => import('@/views/System/SystemRole/SystemRole'), // 角色管理
      },
      {
        path: '/SystemUser',
        name: 'SystemUser',
        component: () => import('@/views/System/SystemUser/SystemUser'), // 用户管理
      },
      {
        path: '/SystemMenu',
        name: 'SystemMenu',
        component: () => import('@/views/System/SystemMenu/SystemMenu'), // 菜单管理
      },
      {
        path: '/SystemBackstageData',
        name: 'SystemBackstageData',
        component: () =>
          import('@/views/System/SystemBackstageData/SystemBackstageData'), // 表字典
      },
      {
        path: '/SystemBaseEnumData',
        name: 'SystemBaseEnumData',
        component: () =>
          import('@/views/System/SystemBaseEnumData/SystemBaseEnumData'), // 枚举字典
      },
      {
        path: '/SystemBaseBarCode',
        name: 'SystemBaseBarCode',
        component: () =>
          import('@/views/System/SystemBaseBarCode/SystemBaseBarCode'), // 编码规则
      },
      {
        path: '/SystemCardTemplate',
        name: 'SystemCardTemplate',
        component: () =>
          import('@/views/System/SystemCardTemplate/SystemCardTemplate'), // 设备卡模板
      },
      {
        path: '/User',
        name: 'User',
        component: () => import('@/views/User/User'), // 用户信息
      },
      {
        path: '/UserInfo',
        name: 'UserInfo',
        component: () => import('@/views/User/UserInfo'), // 用户详细信息
      },
    ],
  },
  // {
  //   path: '/Main',
  //   component: MainPageLayout,
  //   hidden: true,
  // },
  {
    path: '/UserSign',
    name: 'UserSign',
    component: () => import('@/views/UserH5/UserSign.vue'), // 用户签到（H5）
  },
  {
    path: '/404',
    component: () => import('@/views/exception/404'), // 404页面
  },
]
